// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"154a66f6","513":"68496603"}[chunkId] + ".chunk.js";
};